<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/avRSDS/tc-custom/9781398430976.jpg?1705541150967" alt="This image is the cover for the book The Adventures at Hog Farm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Adventures at Hog Farm
      </h1>
      <p class="bookDescription body article font2">
        <p>The Adventures at Hog Farm: The Kittens Tale tells the story of three little kittens, Jerry, Mia and Emi, and their life with all the other animals on Hog Farm. Enjoy reading about everyday fun things animals get up to… but told through their eyes! Jerry, the big brother, the protector; Emi the adventurous and brave; and Mia, gentle and thoughtful. Come into the world of Hog Farm and let the adventures begin.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christine Kavanagh
      </h2>
      
      <p class="authorDescription body article">Christine Kavanagh loves to see the personality in animals. All of the animals contained within The Adventures at Hog Farm books were real animals which Christine had observed when she lived on a farm in North Yorkshire, England. At aged 60, she decided to share her experiences with her readers and hope they enjoy reading about them as much as she did seeing it all happen.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?121a551c